export default __webpack_public_path__ + "static/media/notChecked.4d31e310.svg";